import controller from './historyChart.controller.js';
import template from './historyChart.html';

const historyChartComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default historyChartComponent;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/historyChart/historyChart.component.js
 **/